export const contentTableConfig = {
  title: '使用明细',
  propList: [
    {
      prop: 'menu',
      label: '菜单名称',
      minWidth: '80'
    },
    {
      prop: 'module',
      label: '模块名称',
      minWidth: '80'
    },
    {
      prop: 'func',
      label: '功能名称',
      minWidth: '80'
    },
    {
      prop: 'apiAbbr',
      label: 'Api链接',
      minWidth: '80'
    },
    {
      prop: 'username',
      label: '访问人',
      minWidth: '80'
    },
    {
      prop: 'accessTime',
      label: '访问时间',
      minWidth: '80'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
